import type { DtsOutboundKafkaDto } from '@dhl/mdp-api'
import { presentDateOrDefault } from '~/modules/ppp/submodules/relations/utils'
import { DataRow, DataHeading } from '~/modules/ppp/submodules/relations/components/data'

type Props = {
  config: DtsOutboundKafkaDto
}
export const OutboundKafka = ({ config }: Props) => (
  <>
    <DataHeading title="Outbound Kafka" />
    <DataRow title="createdOn" payload={presentDateOrDefault(config.createdOn)} />
    <DataRow title="clientId" payload={config.clientId} withCopy />
    <DataRow title="outName" payload={config.outName} withCopy />
    <DataRow title="topicName" payload={config.topicName} withCopy />
  </>
)
